import { render, staticRenderFns } from "./UpdateFund.vue?vue&type=template&id=1c227a7c&scoped=true&"
import script from "./UpdateFund.vue?vue&type=script&lang=js&"
export * from "./UpdateFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c227a7c",
  null
  
)

export default component.exports